const GET_RESTAURANT_SETTINGS_ERROR_TEXT = "Une erreur est survenue lors du chargement des paramètres du restaurant.";
const UPDATE_RESTAURANT_SETTINGS_ERROR_TEXT = "Une erreur est survenue lors de la modification des paramètres du restaurant.";

const GET_EMAIL_SETTINGS_ERROR_TEXT = "Une erreur est survenue lors du chargement des paramètres de notification par e-mail.";
const UPDATE_EMAIL_SETTINGS_ERROR_TEXT = "Une erreur est survenue lors de la modification des paramètres de notification par e-mail.";

export const GET_RESTAURANT_SETTINGS_ERROR = GET_RESTAURANT_SETTINGS_ERROR_TEXT;
export const UPDATE_RESTAURANT_SETTINGS_ERROR = UPDATE_RESTAURANT_SETTINGS_ERROR_TEXT;

export const GET_EMAIL_SETTINGS_ERROR = GET_EMAIL_SETTINGS_ERROR_TEXT;
export const UPDATE_EMAIL_SETTINGS_ERROR = UPDATE_EMAIL_SETTINGS_ERROR_TEXT;

const GET_OPENING_HOURS_ERROR_TEXT = "Une erreur est survenue lors du chargement des horaires d'ouverture.";
export const GET_OPENING_HOURS_ERROR = GET_OPENING_HOURS_ERROR_TEXT;
const ADD_OPENING_HOUR_ERROR_TEXT = "Une erreur est survenue lors l'ajout de l'horaire.";
export const ADD_OPENING_HOUR_ERROR = ADD_OPENING_HOUR_ERROR_TEXT;
const UPDATE_OPENING_HOUR_ERROR_TEXT = "Une erreur est survenue lors de la modification de l'horaire.";
export const UPDATE_OPENING_HOUR_ERROR = UPDATE_OPENING_HOUR_ERROR_TEXT;
const DELETE_OPENING_HOUR_ERROR_TEXT = "Une erreur est survenue lors de la suppression de l'horaire.";
export const DELETE_OPENING_HOUR_ERROR = DELETE_OPENING_HOUR_ERROR_TEXT;

const GET_CUSTOM_EVENTS_ERROR_TEXT = "Une erreur est survenue lors du chargement des options personnalisées.";
export const GET_CUSTOM_EVENTS_ERROR = GET_CUSTOM_EVENTS_ERROR_TEXT;
const ADD_CUSTOM_EVENT_ERROR_TEXT = "Une erreur est survenue lors l'ajout de l'option personnalisée.";
export const ADD_CUSTOM_EVENT_ERROR = ADD_CUSTOM_EVENT_ERROR_TEXT;
const UPDATE_CUSTOM_EVENT_ERROR_TEXT = "Une erreur est survenue lors de la modification de l'option personnalisée.";
export const UPDATE_CUSTOM_EVENT_ERROR = UPDATE_CUSTOM_EVENT_ERROR_TEXT;
const DELETE_CUSTOM_EVENT_ERROR_TEXT = "Une erreur est survenue lors de la suppression de l'option personnalisée.";
export const DELETE_CUSTOM_EVENT_ERROR = DELETE_CUSTOM_EVENT_ERROR_TEXT;

export const GET_MESSAGE_SAMPLES_ERROR = "Une erreur est survenue lors du chargement des messages-type.";
export const ADD_MESSAGE_SAMPLE_ERROR = "Une erreur est survenue lors de l'ajout du message-type.";
export const UPDATE_MESSAGE_SAMPLE_ERROR = "Une erreur est survenue lors de la modification du message-type.";
export const DELETE_MESSAGE_SAMPLE_ERROR = "Une erreur est survenue lors de la suppression du message-type.";

export const GET_RESERVATION_CONDITIONS_ERROR = "Une erreur est survenue lors du chargement des conditions de réservation."
export const ADD_RESERVATION_CONDITION_ERROR = "Une erreur est survenue lors de l'ajout de la condition de réservation."
export const UPDATE_RESERVATION_CONDITION_ERROR = "Une erreur est survenue lors de la modification de la condition de réservation."
export const DELETE_RESERVATION_CONDITION_ERROR = "Une erreur est survenue lors de la suppression de la condition de réservation."

export const GET_SPECIAL_OPTION_CATEGORIES_ERROR = "Une erreur est survenue lors du chargement des catégories d'option spéciale."
export const ADD_SPECIAL_OPTION_CATEGORY_ERROR = "Une erreur est survenue lors de l'ajout de la catégorie d'option."
export const UPDATE_SPECIAL_OPTION_CATEGORY_ERROR = "Une erreur est survenue lors de la modification de la catégorie d'option."
export const DELETE_SPECIAL_OPTION_CATEGORY_ERROR = "Une erreur est survenue lors de la suppression de la catégorie d'option."

export const GET_SPECIAL_OPTIONS_ERROR = "Une erreur est survenue lors du chargement des options spéciales."
export const ADD_SPECIAL_OPTION_ERROR = "Une erreur est survenue lors de l'ajout de l'option."
export const UPDATE_SPECIAL_OPTION_ERROR = "Une erreur est survenue lors de la modification de l'option."
export const DELETE_SPECIAL_OPTION_ERROR = "Une erreur est survenue lors de la suppression de l'option."



// WEBPACK FOOTER //
// ./src/errors/settings.js